import views from '../views'

export default [{
    name: 'user-scanCode',
    path: '/my/user-scanCode',
    component: views.my.scanCode,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "扫码"
    }
}, {
    name: 'user-tourist',
    path: '/ad/:ercode',
    component: views.my.tourist,
    meta: {
        requiresWxUser: true,
        title: "活动页"
    }
}, {
    name: 'user-operators',
    path: '/my/user-operators',
    component: views.my.operators,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "扫码"
    }
}, {
    name: 'user-codeRecord',
    path: '/my/user-codeRecord',
    component: views.my.codeRecord,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "扫码历史记录"
    }
}, {
    name: 'user-statistics',
    path: '/my/user-statistics',
    component: views.my.statistics,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "点盖数统计"
    }
}, {
    name: 'user-packQrcode',
    path: '/my/user-packQrcode',
    component: views.my.packQrcode,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "瓶盖打包"
    }
}, {
    name: 'user-continuity',
    path: '/my/user-continuity',
    component: views.my.continuity,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "连续扫码"
    }
}, {
    name: 'user-password',
    path: '/my/user-password',
    component: views.my.passWord,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "修改密码"
    }
}, {
    name: 'user-formList',
    path: '/my/user-formList',
    component: views.my.formList,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "提交列表"
    }
}, {
    name: 'user-formDetail',
    path: '/my/user-formDetail',
    component: views.my.formDetail,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "表单详情"
    }
}, {
    name: 'user-formSubmit',
    path: '/my/user-formSubmit',
    component: views.my.formSubmit,
    meta: {
        login: true,
        requiresWxUser: true,
        title: "提交表单"
    }
}]



// WEBPACK FOOTER //
// ./src/router/my.js